<template>
  <md-dialog :md-active.sync="show" md-close-on-esc="false" @md-clicked-outside="closeDialog" @keyup.esc="closeDialog">
    <md-dialog-title v-if="isEditMode">Edit Configuration ({{ _key }})</md-dialog-title>
    <md-dialog-title v-else>Add New Configuration</md-dialog-title>

    <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <div class="md-subheading warning-text">
        <md-autocomplete v-if="!isEditMode" v-model="_key" :md-options="Object.keys(helper)" required>
          <label>Key</label>
        </md-autocomplete>
        <md-field v-else required>
          <label>Key</label>
          <md-input v-model="_key" disabled="true"></md-input>
        </md-field>

        <md-field v-if="!helper || !helper[_key] || typeof helper[_key] === 'string'">
          <label>Value</label>
          <md-textarea v-model="value" required></md-textarea>
          <span class="md-helper-text">{{ helper[_key] }}</span>
        </md-field>
        <md-field v-else-if="helper[_key]['type']" class="fields" :class="editClass">
          <label>Value</label>
          <md-switch v-if="helper[_key]['type'] === 'switch'" v-model="value" required></md-switch>
          <md-select
            v-else-if="['select', 'log', 'multiselect'].includes(helper[_key]['type']) && helper[_key]['options']"
            v-model="value"
            required
            :multiple="helper[_key]['type'] === 'multiselect'"
          >
            <md-option v-for="option in helper[_key]['options']" v-bind:key="option" :value="option">
              {{ option }}
            </md-option>
          </md-select>
          <md-input v-else :type="helper[_key]['type']" v-model="value" md-autogrow required></md-input>
          <span class="md-helper-text">{{ helper[_key]["helper"] }}</span>
          <span class="md-error" v-if="errorMessage">{{ errorMessage }}</span>
        </md-field>
      </div>
    </div>
    <md-dialog-actions>
      <md-button @click="doSave()" class="md-primary">Save</md-button>
      <md-button @click="closeDialog">Close</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: "AddEditConfigurationItem",
  props: ["show", "_key", "value", "isEditMode", "helper"],
  data() {
    return {
      errorMessage: null,
    };
  },
  computed: {
    editClass() {
      return {
        "md-invalid": this.errorMessage,
      };
    },
  },
  methods: {
    closeDialog() {
      this.errorMessage = null;
      this.$emit("close");
    },
    notifyVue: function (verticalAlign, horizontalAlign, message) {},
    async doSave() {
      this.errorMessage = null;
      const params = {
        key: this._key,
      };
      if (typeof this.value === "object") {
        params.value = JSON.stringify(this.value);
      } else {
        params.value = this.value;
      }
      const response = await this.$api.setServerConfiguration({ params });
      if (response.status === 200) {
        this.errorMessage = null;
        this.$notify({
          message: `${this.isEditMode ? "Edited" : "Created"} successfully.`,
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        this.$emit("saved");
      } else {
        // If a required parameter is missing
        if (response.data.code === 40001) this.errorMessage = `Required parameter ${response.parsedError} is missing.`;
        else this.errorMessage = response.parsedError;
      }
    },
  },
};
</script>

<style lang="scss">
.md-menu-content {
  z-index: 15 !important;
}

.fields {
  width: 100%;
}

.md-field.md-theme-default.md-disabled label,
.md-field.md-theme-default.md-disabled .md-input,
.md-field.md-theme-default.md-disabled .md-textarea {
  -webkit-text-fill-color: rgba(0, 0, 0, 0.42) !important;
}
</style>
